import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '韩国漫画', href: '/category/korea' },
    { label: '热血少年', href: '/category/shonen' },
    { label: '恋爱言情', href: '/category/romance' },
  ],
  support: [
    { label: '关于我们', href: '/about' },
    { label: '用户协议', href: '/about#terms' },
    { label: '隐私政策', href: '/about#privacy' },
    { label: '版权声明', href: '/about#copyright' },
  ],
  social: [
    { icon: 'ri-weibo-line', label: '微博', href: '#' },
    { icon: 'ri-wechat-line', label: '微信', href: '#' },
    { icon: 'ri-bilibili-line', label: 'Bilibili', href: '#' },
    { icon: 'ri-tiktok-line', label: '抖音', href: '#' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-6 md:px-10 py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-background-50"></i>
              </div>
              <span className="text-2xl md:text-3xl font-bold font-heading text-background-50 whitespace-nowrap">
                虫虫漫画
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              虫虫漫画网 —— 下拉式完整版免费阅读平台。专注韩国无删减漫画，下拉观看流畅不卡顿，免费为您呈现各类精彩韩国漫画的完整版剧情与画面。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {footerLinks.social.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  rel="nofollow"
                  className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 font-medium mb-4 font-label">
              导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 font-medium mb-4 font-label">
              支持
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-wider text-foreground-400 font-medium mb-4 font-label">
              联系我们
            </h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-300">
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-base text-foreground-400 mt-0.5"></i>
                <span>contact@chongchongmanhua.com</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-base text-foreground-400 mt-0.5"></i>
                <span>中国上海市浦东新区张江高科技园区</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-base text-foreground-400 mt-0.5"></i>
                <span>400-888-6666</span>
              </div>
            </div>
            <div className="mt-5">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20smartphone%20displaying%20a%20comic%20page%20with%20vibrant%20manga%20characters%2C%20warm%20atmospheric%20lighting%2C%20dark%20background%20with%20subtle%20gradient%2C%20modern%20minimal%20composition%2C%20digital%20art%20aesthetic%2C%20rich%20colors%20pop%20against%20dark%20backdrop%2C%20clean%20professional%20look%2C%20high%20quality%20illustration&width=400&height=280&seq=footer-qr-manga&orientation=portrait"
                alt="虫虫漫画网 手机阅读界面"
                title="虫虫漫画网 - 下拉式漫画免费阅读"
                className="w-32 h-22 rounded-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800/40">
        <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 虫虫漫画网 ChongChongManhua.com 版权所有
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/about#terms"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              用户协议
            </Link>
            <Link
              to="/about#privacy"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              隐私政策
            </Link>
            <Link
              to="/about"
              className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}